import React, { Component } from 'react';
import { Field, reduxForm, getFormSubmitErrors, change } from 'redux-form';
import { renderCheckbox, renderInput, renderSpecialInput, fields } from './Fields';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from './validation';
import _ from 'lodash';

class CasoFormStep2 extends Component{
    constructor(props) {
        super(props);
        let fieldsForm =fields.stepTwo.map(item => {
           item.active = this.props.summary[_.snakeCase(item.name)] || false;
           item.items.map(subitem => {
               subitem.input = this.props.summary[_.snakeCase(subitem.name + " " + item.name)] || false;
               return subitem;
           })
           return item;
        });

        this.state = { fieldsForm }
    }
    createSubFields(items, position, change){
        return items.map( (item, index) => (
            <div className="col-md-6" key={item.name + index + position}>
                <Field
                    disabled={!item.active}
                    name={_.snakeCase(item.name+this.state.fieldsForm[position].name)}
                    component={renderCheckbox}
                    label={item.name}
                    id={item.name}
                    onChange={(e) => {
                        change(_.snakeCase(item.name+this.state.fieldsForm[position].name+"Text"), null)
                        let newState = this.state.fieldsForm
                        newState[position].items[index].input = !item.input
                        this.setState({ fieldsForm: newState })
                    }}
                />
                <Field
                    disabled={!item.input}
                    name={_.snakeCase(item.name+this.state.fieldsForm[position].name+"_text")}
                    type="text"
                    component={renderSpecialInput}
                />
            </div>
        ));
    }
    render(){
        const { handleSubmit, invalid, submitFailed, errors, change} = this.props
        const suberr = getFormSubmitErrors("step2")
        const error_msg = () => {
            if(!this.state.fieldsForm.arcada_superior && !this.state.fieldsForm.arcada_superior){
                return (<span><i className="fa fa-warning" /> Debe elegir al menos una arcada y una de sus opciones para poder continuar</span>)
            }
        }

        return(
            <form name="step2" onSubmit={handleSubmit}>
                <div className="row">
                    {this.state.fieldsForm.map((group, i) => {
                        let selectGroup = () => {
                            let newState = this.state.fieldsForm
                            newState[i].active = !group.active
                            this.setState({ fieldsForm: newState })
                        }
                        return(
                            <div className="col-md-6" key={i}>
                                <h5>
                                <Field
                                    name={_.snakeCase(group.name)}
                                    component={renderCheckbox}
                                    label={group.name}
                                    id={group.name}
                                    value={group.checked}
                                    onChange={selectGroup}
                                />
                                </h5>
                                <div className="form-row">
                                    {group.active && this.createSubFields(group.items, i, change)}
                                </div>
                            </div>
                        )
                    })
                    }
                </div>
                {invalid && submitFailed && <div className="alert alert-danger">{error_msg()}</div>}


                <div className="form-actions">
                    <button type="submit" onClick={this.props.previousPage} className="btn btn-secondary next"><i className="fa fa-chevron-left"></i>&nbsp; Anterior</button>
                    <button type="submit" className="btn btn-primary next float-right">Siguiente &nbsp;<i className="fa fa-chevron-right"></i></button>
                </div>
            </form>
        )
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({
            change
        }, dispatch)
    };
}
CasoFormStep2 = connect(
    mapDispatchToProps
)(CasoFormStep2);

export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
})(CasoFormStep2);



// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/CasoFormStep2.jsx